import React from 'react';
import moment from 'moment';

import { Money } from 'components/money';
import { formatNumber } from 'utils/numbers';
import { DateTimeFormat, DateFormat, ServerDateFormat, ServerTimeFormat, TimeFormat } from 'utils/constants';
import { BoldContainer, DateContainer } from './elements';

import type { RenderedCell } from 'rc-table/lib/interface';

export const renderDummy = () => <span>–</span>;

export const renderValue = (value: string | number) => <span title={`${value}`}>{value}</span>;

export const renderText = (name: string) => (name ? renderValue(name) : renderDummy());

export const renderDateTime = (date: string | null) =>
  date ? <DateContainer>{moment.utc(date).format(DateTimeFormat)}</DateContainer> : renderDummy();

export const renderDateAndTime = (date: string | null, time: string | null) =>
  date && time ? (
    <DateContainer>
      {moment(time, ServerTimeFormat).format(TimeFormat) + '\r\n' + moment(date, ServerDateFormat).format(DateFormat)}
    </DateContainer>
  ) : (
    renderDummy
  );
export const renderDate = (date: string | null) =>
  date ? <DateContainer>{moment(date, ServerDateFormat).format(DateFormat)}</DateContainer> : renderDummy();

export const renderTime = (time?: string | null) =>
  time ? <DateContainer>{moment(time, ServerTimeFormat).format(TimeFormat)}</DateContainer> : renderDummy();

export const renderTimeRange = (startTime?: string | null, endTime?: string | null) => (
  <DateContainer>
    {startTime ? moment(startTime, ServerTimeFormat).format(TimeFormat) : renderDummy()}
    <span> - </span>
    {endTime ? moment(endTime, ServerTimeFormat).format(TimeFormat) : renderDummy()}
  </DateContainer>
);

export const renderPreText = (value: string) => <DateContainer>{renderText(value)}</DateContainer>;

export const getNumber = (value?: number | string): string => {
  const parts = (value || 0).toString().split('.');
  return parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') + (parts[1] ? '.' + parts[1] : '');
};

export const renderNumber = (value?: number | string) => renderValue(getNumber(value));

export const renderMoney = (value: number) => <Money key={value} value={formatNumber(value)} />;

export const renderBoolean = (value: boolean | null) => renderValue(Boolean(value) ? 'Yes' : 'No');

type ColumnRenderType<RecordType> = (
  value: any,
  record: RecordType,
  index: number
) => React.ReactNode | RenderedCell<RecordType>;
type RenderBoldWrapperType = <RecordType>(
  render: ColumnRenderType<RecordType>
) => (value: any, record: RecordType, index: number) => React.ReactNode | RenderedCell<RecordType>;

export const renderBoldWrapper: RenderBoldWrapperType = (renderer) => (value, record, index) =>
  <BoldContainer>{renderer(value, record, index)}</BoldContainer>;

